import type { ComponentProps } from "react";
import logoHorizontal from "@/assets/brand/logo/caseblink-logo-horizontal.png";
import { cn } from "@/lib/utils";

type Props = Omit<ComponentProps<"img">, "src" | "alt" | "children"> & {
  /** Defaults to "CaseBlink"; pass "" for decorative use. */
  alt?: string;
};

/**
 * Horizontal CaseBlink lockup (mark + wordmark). Set the height with
 * `className` (e.g. `h-8`); width follows the 1024x198 aspect ratio.
 */
export function BrandLogo({ alt = "CaseBlink", className, ...rest }: Props) {
  return (
    <img
      src={logoHorizontal}
      alt={alt}
      draggable={false}
      className={cn(
        "h-8 w-auto max-w-full select-none object-contain object-left",
        className
      )}
      {...rest}
    />
  );
}
